export const RESET_STORE = 'RESET_STORE';

interface ResetStoreAction {
  type: typeof RESET_STORE;
}

export const resetStore = (): ResetStoreAction => ({
  type: RESET_STORE,
});
